import { render, staticRenderFns } from "./LinkPreviewWidget.vue?vue&type=template&id=988ab83c&scoped=true&"
import script from "./LinkPreviewWidget.vue?vue&type=script&lang=ts&"
export * from "./LinkPreviewWidget.vue?vue&type=script&lang=ts&"
import style0 from "./LinkPreviewWidget.vue?vue&type=style&index=0&id=988ab83c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988ab83c",
  null
  
)

export default component.exports